import React, { useEffect, useState } from "react";
import {
  formatDataRefreshStatusLabel,
  isDataRefreshStale,
} from "../shared/utils/refreshAgeDisplay";

function RefreshIcon({ spinning }) {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={spinning ? "data-refresh-control__icon--spin" : undefined}
    >
      <path d="M21 12a9 9 0 1 1-2.64-6.36" />
      <path d="M21 3v6h-6" />
    </svg>
  );
}

/**
 * Timestamp + refresh icon control (age shown in whole hours).
 */
export default function DataRefreshControl({
  source,
  lastRefreshedAt,
  refreshing = false,
  disabled = false,
  onRefresh,
  title,
}) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!lastRefreshedAt) return undefined;
    const id = window.setInterval(() => setTick((n) => n + 1), 60_000);
    return () => window.clearInterval(id);
  }, [lastRefreshedAt]);

  const stale = !refreshing && isDataRefreshStale(lastRefreshedAt);
  const statusLabel = refreshing ? "Refreshing…" : formatDataRefreshStatusLabel(lastRefreshedAt);
  // tick keeps relative age current without remounting
  void tick;

  const refreshTitle =
    title ||
    (refreshing
      ? "Refresh in progress"
      : stale
        ? `Data is over 24 hours old — refresh from ${source}`
        : lastRefreshedAt
          ? `Refresh ${source}`
          : `Refresh from ${source}`);

  const rootClassName = [
    "data-refresh-control",
    refreshing ? "data-refresh-control--refreshing" : "",
    stale ? "data-refresh-control--stale" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClassName} aria-busy={refreshing || undefined}>
      <span className="data-refresh-control__label">{statusLabel}</span>
      <button
        type="button"
        className="data-refresh-control__btn"
        disabled={disabled || refreshing}
        onClick={onRefresh}
        title={refreshTitle}
        aria-label={refreshTitle}
      >
        <RefreshIcon spinning={refreshing} />
      </button>
    </div>
  );
}
